export const countConversationsCreated = {
  analysisType: 'count',
  eventCollection: 'conversation.created',
  key: 'countConversationsCreated',
}
